import { Header } from 'components/index';
import { Outlet } from 'react-router-dom';

const AuthentifiedLayout = () => (
    <>
        <Outlet />
    </>
);

export default AuthentifiedLayout;
